import './Contacts.css';

import { useEffect, useState } from "react";

import telegramIcon from '../../assets/images/icons/tg_icon.svg';
import instIcon from '../../assets/images/icons/inst_icon.svg';

const Contacts: React.FC = () => {
    const [isVisible, setVisible] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setVisible(true);
    }, []);

    return (
        <div className={`contacts ${isVisible ? 'visible' : ''}`}>
            <div className='contacts_details'>
                <h3 className='contacts_details_title'>Контакты</h3>
                <h5 className='contacts_details_companyName'>Miartcom</h5>

                <div className="contacts_info">
                    <p><strong>Наименование организации:</strong> Индивидуальный предприниматель ОСИПОВА МАРИЯ АЛЕКСАНДРОВНА</p>
                    <p><strong>ИНН:</strong> 781696986441</p>
                    <p><strong>ОГРНИП:</strong> 314784704200170</p>
                    <p><strong>Расчетный счет:</strong> 40802810755000077620</p>
                    <p><strong>Банк:</strong> ПАО Сбербанк</p>
                    <p><strong>Корр. счет:</strong> 30101810500000000653</p>
                    <p><strong>БИК:</strong> 044030653</p>
                    <p><strong>Адрес:</strong> 192071, Санкт-Петербург, Славы пр-кт, д. 20, кв. 102</p>
                    <p><strong>Email:</strong> miartcom@mail.ru</p>
                    <p><strong>Телефон:</strong> <a href="tel:+79119019000">8 (911) 901 - 90 - 00</a></p>

                    <div className="contacts_contactsIcons">
                        <a className="profile_contact" href='https://www.instagram.com/miartcomprostranstvo?igsh=Y2Y2M2JyZXh2bmN2&utm_source=qr' target='_blank' rel="noreferrer">
                            <img src={instIcon} alt="vk" />
                        </a>

                        <a className="profile_contact" href='https://t.me/MIARTCOM2023' target='_blank' rel="noreferrer">
                            <img src={telegramIcon} alt="telegram" />
                        </a>
                    </div>
                </div>
            </div>

            <div className='contacts_map'>
                <iframe
                    src="https://yandex.ru/map-widget/v1/?ll=30.245291%2C59.962587&z=16&pt=30.245291,59.962587,pm2rdm"
                    allowFullScreen
                ></iframe>
            </div>
        </div>
    );
};

export default Contacts;
